import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { TableOptions, TableMessages } from 'src/app/classes/table-options';
import { UserType } from 'src/app/user-roles';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { JsonViewerComponent } from '../../json-viewer/json-viewer.component';
import { BootReasonType } from 'src/app/types/BootReasonType';
import { TranslateService } from '@ngx-translate/core';
import { sanitizeObject } from 'src/app/helpers/file';
import moment from 'moment';
import { HttpInterceptorService } from '@smartcharge/portal/services';
import { BoxResponsesComponent } from '../../command-responses/box-responses/box-responses.component';

@Component({
  selector: 'sc-action-history-table',
  templateUrl: './action-history-table.component.html',
  styleUrls: ['./action-history-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ActionHistoryTableComponent implements OnInit {
  @Input() actions: any[] = [];
  @Input() tableOptions: TableOptions = new TableOptions();
  @Input() loading: boolean = true;
  @Input() refreshing: boolean = false;
  @Input() messages: TableMessages = new TableMessages();
  @Input() point: any = null;
  @Input() showPoint: boolean = true;
  @Input() showCustomer: boolean = true;

  @Output() route: EventEmitter<any> = new EventEmitter();
  @Output() page: EventEmitter<any> = new EventEmitter();

  userType = UserType;

  selectedAction: any = {};
  selectedChargingProfile: any = {};

  @Input() fixedHeight: string = null;
  @Input() scrollable: boolean = false;

  constructor(
    private _http: HttpInterceptorService,
    private dialog: MatDialog,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.initTableMessages();
  }

  initTableMessages() {
    const messages = new TableMessages();
    this.messages.totalMessage = this.translate.instant(messages.totalMessage);
    this.messages.emptyMessage = this.translate.instant(messages.emptyMessage);
    this.messages.errorMessage = this.translate.instant(messages.errorMessage);
  }

  selectAction(action) {
    this.selectedAction = action;
  }

  setProfile(action) {
    this.selectedChargingProfile = action.datas;
  }

  onRoute() {
    this.route.emit();
  }

  onPage(e) {
    this.tableOptions = Object.assign(this.tableOptions, e);

    this.loading = true;
    this.page.emit(e);
  }

  onLimitChange(limit: number) {
    this.tableOptions.limit = limit;
    this.tableOptions.offset = 0;
    this.loading = true;
    this.page.emit({ offset: 0, limit });
  }

  showAction(action) {
    if (!action) return;

    if (this.point) {
      this._http
        .get(
          `OcppLog/FindOffset/${this.point.DeviceID}/${moment(action.UTC_log).unix() * 1000}/${this.point.FK_ChargingBoxID}`
        )
        .subscribe((offset) => {
          let dialogRef: MatDialogRef<JsonViewerComponent>;
          dialogRef = this.dialog.open(JsonViewerComponent, { width: '80vw' });
          dialogRef.componentInstance.json = sanitizeObject(action);
          dialogRef.componentInstance.title = this.translate.instant(action.typeLog);
          dialogRef.componentInstance.date = action.Date_log;
          dialogRef.componentInstance.dateDetailsLink = `/station/${action.FK_ChargingStationID}/point/${this.point.PK_ChargePointID}/log/${this.point.DeviceID}/${this.point.FK_ChargingBoxID}/${offset}`;
        });
    } else {
      let dialogRef: MatDialogRef<JsonViewerComponent>;
      dialogRef = this.dialog.open(JsonViewerComponent, { width: '80vw', maxWidth: '1000px' });
      dialogRef.componentInstance.json = sanitizeObject(action);
      dialogRef.componentInstance.title = this.translate.instant(action.typeLog);
      dialogRef.componentInstance.date = action.Date_log;
    }
  }

  showRequestDetails(action) {
    const dialogRef: MatDialogRef<BoxResponsesComponent> = this.dialog.open(BoxResponsesComponent, {
      autoFocus: false,
      width: '80vw'
    });
    dialogRef.componentRef.setInput('requestBoxID', action.FK_CommandRequestBoxId);
  }

  getReasonText(type: BootReasonType) {
    return (type && BootReasonType[type]) || null;
  }

  getRowClass(row: any): string {
    if (row?.IsError) return 'datatable-body-row--error datatable-body-row--bold';
    if (row?.IsWarning) return 'datatable-body-row--warning datatable-body-row--bold';
    switch (row.typeLog) {
      case 'AUTOHEAL':
        return 'datatable-body-row--success datatable-body-row--bold';
      case 'NEW_FIRMWARE':
      case 'TRANSACTION_INFORMATION':
        return 'datatable-body-row--important datatable-body-row--bold';
      default:
        return '';
    }
  }
}
